/*
JTM outside builder - scripts
- builder buttons
*/

// temp remove
if (localStorage.getItem('selectedFabric')) {
  localStorage.removeItem('selectedFabric');
} 
// temp remove

document.addEventListener('DOMContentLoaded', function () {

  //console.log("loaded");
  
  ///////////////////////////////////////////
  // start - builder buttons get and set localStorage - sessionStorage
  //waitForElm('html.is-products #builder-buttons-box', true).then((elm) => {
  $q('html.is-products #builder-buttons-box').wait(true,(elm) => {
    
    const builderBox = document.getElementById('builder-buttons-box');
    builderBox.addEventListener('click', function (e) { 

      //console.log('test');
        
      e.preventDefault();        
      const anchor = e.target.closest('a');
      if (anchor && builderBox.contains(anchor)) {
  
        const data = {};
        for (const key in anchor.dataset) {
            data[key] = anchor.dataset[key];
        }  
        setSelectedFabric(data);
        setTimeout(function(){
          // Optional: redirect after storing
          window.location.href = anchor.href;
        },300);
      }
    });   
  });

  // only run on builder product pages
  //waitForElm('html.is-products.is-builder #cd-builder #cd-step-fabric .control [data-cd-option-name].cd-input', true).then((elm) => {
  $q('html.is-products.is-builder #cd-builder #cd-step-fabric .control [data-cd-option-name].cd-input').wait(true,(elm) => {

    if (sessionStorage.getItem('selectedFabric') && document.querySelector('html.is-products.is-builder') !== null) {
        //waitForElm('html.is-products.is-builder #cd-builder #cd-step-fabric #cd-fabric-picker--box', true).then((elm) => {
           getSelectedFabricPopulateFields();
        //});
    }    
  });

  function splitCamelCase(str) {
    return str.replace(/([A-Z])/g, '-$1').toLowerCase();
  }

  function toCamelCase(str) {
    return str.replace(/-([a-z])/g, (_, letter) => letter.toUpperCase());
  }

  // Store selected fabric data in sessionStorage - localStorage
  function setSelectedFabric(data) {    
    sessionStorage.setItem('selectedFabric', JSON.stringify(data));
  }

  // Get selected fabric data from sessionStorage - localStorage
  function getSelectedFabric() {    
    const stored = sessionStorage.getItem('selectedFabric');
    return stored ? JSON.parse(stored) : null;
  }
  
  // Define which fields you want to populate (must match input[name] attributes)
  const fabricFields = ['fabric-width', 'fabric-design', 'fabric-price', 'fabric-name-sku', 'fabric-image-url', 'welt-width', 'welt-fabric-design', 'welt-price', 'welt-name-sku', 'welt-image-url'];

  function capitalizeWordsString(str) {
    return str.replace(/\b\w/g, char => char.toUpperCase());
  }
  
  // Get selected fabric data and populate form fields from sessionStorage - localStorage
  function getSelectedFabricPopulateFields() {

    //console.log('getSelectedFabricPopulateFields()');

    //const builderButtonText = ["fabric", "fabricWidth", "fabricDesign"];
    //const key = "fabricDesign";
    //builderButtonText.includes(storedBuilderButtonLastClicked)
    let cushionBuilderText = document.querySelector("#itoris_dynamicproductoptions").dataset.cushionBuilderText;
    const stored = sessionStorage.getItem('selectedFabric');
    const storedBuilderButtonLastClicked = sessionStorage.getItem('builderButtonLastClicked');
    //console.log('cushionBuilderText 1', cushionBuilderText);
    if(cushionBuilderText == ""){
      cushionBuilderText =  document.querySelector("#itoris_dynamicproductoptions").dataset.builderType;
      cushionBuilderText = cushionBuilderText.replace('-',' ');
      cushionBuilderText = capitalizeWordsString(cushionBuilderText);
    }
    //console.log('cushionBuilderText 2', cushionBuilderText);
    if (!stored && (storedBuilderButtonLastClicked === cushionBuilderText)) return;

    const data = JSON.parse(stored);

    //console.log(data['builderButton']);
    //console.log(cushionBuilderText);

    if (data['builderButton'] !== cushionBuilderText) return;
    
    let cdStepFabric = document.querySelector('html.is-products.is-builder #cd-step-fabric');
    // Only loop over fields you've explicitly listed
    fabricFields.forEach(fieldName => {
      let input;
      let fieldNameCamelCase = toCamelCase(fieldName);
      if ((input = cdStepFabric.querySelector(`#cd-step-fabric input[data-cd-option-name="cd--${fieldName}"].cd-input`)) !== null && data[fieldNameCamelCase] !== undefined) {
        input.value = data[fieldNameCamelCase];
      }
    });    
    
    // fabric - populate fabric picker box svg image and name label
    //if (document.querySelector('html.is-products.is-builder') !== null) {
      let fabricImageUrl;
      let fabricNameSku;
      let weltImageUrl;
      let weltNameSku;
      if ((fabricImageUrl = cdStepFabric.querySelector('.cd-fabric-picker--img-fabric svg image')) !== null) {
        fabricImageUrl.setAttribute('href', data['fabricImageUrl']);
      }
      if ((fabricNameSku = cdStepFabric.querySelector('.cd-fabric-picker--name-fabric')) !== null) {
        fabricNameSku.textContent = data['fabricNameSku'];
      }
      if ((weltImageUrl = cdStepFabric.querySelector('.cd-fabric-picker--img-welt svg image')) !== null) {
        weltImageUrl.setAttribute('href', data['weltImageUrl']);
      }
      if ((weltNameSku = cdStepFabric.querySelector('.cd-fabric-picker--name-welt')) !== null) {
      	weltNameSku.textContent = data['weltNameSku'];
      }

      if(data['fabricNameSku'].toLowerCase().indexOf('rain') != -1) {
        //waitForElm('#cd-step-fabric [data-cd-option-name="cd--fabric-selection-sunbrella-rain"]', true).then((elm) => {
        $q('#cd-step-fabric [data-cd-option-name="cd--fabric-selection-sunbrella-rain"]').wait(true,(elm) => {
          // auto select rain fabric seelctor
          document.querySelector('#cd-step-fabric [data-cd-option-name="cd--fabric-selection-sunbrella-rain"]').click();
        });
      }
   // }
    return data;
  }

  // Remove selected fabric from sessionStorage - localStorage
  function clearSelectedFabric() {    
    sessionStorage.removeItem('selectedFabric');
  }
  
  // end - builder buttons get and set localStorage - sessionStorage
  ///////////////////////////////////////////

});